import { POPOVER_Z_INDEX } from '@constants/z-index';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';

import { MagicSearchContent } from './components/magic-search-content';
import { MagicSearchPaletteProps } from './magic-search-palette.type';

/**
 * Anchored near the top instead of centred like `ModalV2`, so the input stays put while the results change height.
 * The shortcut can open it over a drawer or an open dropdown, so it shares the popover layer and, mounted last, paints
 * above them; toasts still clear it.
 */
export const MagicSearchPalette = ({ isOpen, onClose }: MagicSearchPaletteProps) => (
  <Dialog open={isOpen} onClose={onClose} className='relative' style={{ zIndex: POPOVER_Z_INDEX }}>
    <DialogBackdrop
      transition
      className='fixed inset-0 backdrop-overlay transition-opacity duration-150 ease-out data-closed:opacity-0 motion-reduce:transition-none'
    />
    <div className='fixed inset-0 flex justify-center sm:px-4 sm:pt-[12dvh]'>
      <DialogPanel
        transition
        aria-label='Search'
        className='flex h-full w-full flex-col overflow-hidden bg-primary shadow-xxl transition duration-150 ease-out data-closed:opacity-0 motion-reduce:transition-none sm:h-fit sm:max-h-[72dvh] sm:max-w-2xl sm:rounded-xl sm:border sm:border-extra-soft sm:data-closed:scale-98'>
        <MagicSearchContent onClose={onClose} />
      </DialogPanel>
    </div>
  </Dialog>
);
